import { ActionReducer, combineReducers } from '@ngrx/store';

import * as fromSettingsUsers from './users/users.reducer';
import * as fromSettingsGroups from './groups/groups.reducer';
import * as fromSettingsRules from './rules/rules.reducer';
import * as fromSettingsWorkflows from './workflows/workflows.reducer';
import * as fromSettingsCustomForms from './custom-forms/custom-forms.reducer';
import * as fromSettingsOrganization from './organization/organization.reducer';

import { Settings } from './settings.state';

const reducers = {
    users: fromSettingsUsers.settingsUsersReducer,
    groups: fromSettingsGroups.settingsGroupsReducer,
    rules: fromSettingsRules.settingsRulesReducer,
    workflows: fromSettingsWorkflows.settingsWorkflowReducer,
    customForms: fromSettingsCustomForms.settingsCustomFormsReducer,
    organization: fromSettingsOrganization.organizationReducer
};

const reducer: ActionReducer<Settings> = combineReducers(reducers);

function settingsReducer(state: any, action: any) {
    return reducer(state, action);
}

export { settingsReducer } 
